import React from "react";

const SvgOpenInFull24px = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props} >
    <polygon points="21,11 21,3 13,3 16.29,6.29 6.29,16.29 3,13 3,21 11,21 7.71,17.71 17.71,7.71"/>
  </svg>
);

export default SvgOpenInFull24px;
